import { TFunction } from 'i18next';
import * as Yup from 'yup';

export const getPasswordValidationSchema = (validationT: TFunction) =>
    Yup.string()
        .required(validationT('Field is required'))
        .min(8, validationT('Password must contain at least 8 symbols'))
        .matches(/^(?=.*[a-z])/, validationT('Password must contain at least one lowercase letter'))
        .matches(/^(?=.*[A-Z])/, validationT('Password must contain at least one uppercase letter'))
        .matches(/^(?=.*[0-9])/, validationT('Password must contain at least one digit'))
        .matches(
            /^(?=.*[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~])/,
            validationT('Password must contain at least one special character')
        );
